import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { ShortBody, Captions } from 'components/Typography';

export const StyledBadge = styled('div')<{ size: number }>`
  background-color: #ff402d;
  border-radius: 100%;
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size}px`};
  margin: 2px 4px;
  padding: 2px;
  text-align: center;
`;

export const NotificationListWrapper = styled(Grid)`
  flex-direction: 'column';
`;
export const NotificationListTitle = styled(ShortBody)`
  padding: 0 16px !important;
  color: #8092a5 !important;
  text-align: left;
  text-transform: capitalize !important;
`;
export const StyledMessage = styled(ShortBody)<{ read: boolean }>`
  flex: 0 0 75%;
  text-align: start;
  color: ${({ read }) => (read ? '#8092a5' : '#162952')} !important;
  font-weight: ${({ read }) => (read ? 300 : 500)} !important;
  font-size: 14px;
  margin: 0 !important;
`;

export const StyledReadZone = styled.div`
  width: 10px;
`;

export const DisplayMoreButton = styled.div`
  color: #0075c9;
  font-size: 14px;
`;
export const StyledNotificationHeader = styled(Grid)`
  padding: 16px 16px;
`;
export const StyledNotificationItem = styled(Grid)`
  border-top: 1px solid #e9ecf4;
  padding: 16px;
  width: 100%;
`;
export const StyledDate = styled(Captions)`
  color: #8092a5 !important;
  font-size: 12px;
  font-weight: lighter;
  flex: 0 0 10%;
`;
export const StyledEmptyMessage = styled(ShortBody)`
  color: #9797af !important;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
`;
